import FD from '../../../RestAPI/fetchData';
import config from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';

const fetchReadingList = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/question-bank/reading`, data);
};
const fetchChapterNameById = async (data) => {
  return await FD.callAPI(`${config.backend_api}/esg/chapter-by-id`, data);
};
const pdfDownloadViaEmail = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/question-bank/pdf-download`, data);
};
module.exports = {
  fetchReadingList,
  fetchChapterNameById,
  pdfDownloadViaEmail,
};



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/QuestionReadingList/ApiService.js